import React, { memo, useEffect, useState } from 'react';
import { Select, Slider, Flex, Modal, Checkbox } from 'antd';
import styles from './sky-drawer.module.css';
import { EnvMapType } from '@src/components/generated/graphql';
import { IconCheck } from './icon-check';

const Sky = ({
  items,
  callBack,
  type,
  isOpen,
  setIsOpen,
  selectedSkybox,
  styles: customStyles,
}) => {
  const [hdriType, setHdriType] = useState<string>('day');
  const [hdriIntensity, setHdriIntensity] = useState<number>(1.0);
  const [envMapType, setEnvMapType] = useState<EnvMapType>(EnvMapType.Hdri);

  useEffect(() => {
    if (selectedSkybox) {
      setHdriType(selectedSkybox.hdriType);
      setHdriIntensity(selectedSkybox.hdriIntensity);
      setEnvMapType(selectedSkybox.envMapType);
    }
  }, [selectedSkybox]);

  const handleHdriTypeChange = (value) => {
    setHdriType(value);
    callBack({
      type,
      hdriType: value,
      hdriIntensity,
      object: selectedSkybox,
      isSkyBox2025: selectedSkybox.isSkyBox2025,
      envMapType: envMapType,
    });
  };

  const handleIntensityChange = (value) => {
    setHdriIntensity(value);
    callBack({
      type,
      hdriType,
      hdriIntensity: value,
      object: selectedSkybox,
      isSkyBox2025: selectedSkybox.isSkyBox2025,
      envMapType: envMapType,
    });
  };

  const onChangeEnvType = (value) => {
    setEnvMapType(value);
    callBack({
      type,
      hdriType,
      hdriIntensity,
      object: selectedSkybox,
      isSkyBox2025: selectedSkybox.isSkyBox2025,
      envMapType: value,
    });
  };

  const envMapTypeOptions = [
    {
      label: 'None',
      value: EnvMapType.None,
    },
    {
      label: 'SkyBox',
      value: EnvMapType.SkyBox,
    },
    {
      label: 'HDRI',
      value: EnvMapType.Hdri,
    },
  ];

  return (
    <>
      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        mask={true}
        closeIcon={true}
        footer={false}
        width={'50%'}
        style={{ right: '-5%' }}
        zIndex={1001}
      >
        <div className={styles.topSection}>
          <h3 className={styles.title}>Sky Settings</h3>
          <Flex vertical gap={20}>
            <Flex>
              {envMapTypeOptions.map((option) => (
                <Checkbox
                  key={option.value}
                  checked={envMapType === option.value}
                  onChange={() => onChangeEnvType(option.value)}
                >
                  {option.label}
                </Checkbox>
              ))}
            </Flex>
            {envMapType !== EnvMapType.None ? (
              <Flex vertical={false} gap={20}>
                <Flex justify='start' align='center' gap={20}>
                  {envMapType === EnvMapType.Hdri ? (
                    <Flex
                      gap={10}
                      align='center'
                      className={styles.hdriTypeWrapper}
                    >
                      <h4 className={styles.hdriTitle}>HDRI Type</h4>
                      <div data-cy='hdri-type-wrapper'>
                        <Select
                          value={hdriType}
                          style={{ width: '100%' }}
                          onChange={handleHdriTypeChange}
                          options={[
                            { value: 'day', label: 'Day' },
                            { value: 'night', label: 'Night' },
                          ]}
                        />
                      </div>
                    </Flex>
                  ) : (
                    <></>
                  )}
                  <Flex
                    gap={10}
                    align='center'
                    className={styles.hdriIntensityWrapper}
                  >
                    <h4 className={styles.hdriTitle}>Env Intensity</h4>
                    <div data-cy='hdri-intensity-wrapper'>
                      <Slider
                        min={0}
                        max={2}
                        step={0.1}
                        value={hdriIntensity}
                        onChange={handleIntensityChange}
                        className={styles.slider}
                      />
                    </div>
                  </Flex>
                </Flex>
              </Flex>
            ) : (
              <></>
            )}

            <div className='overflow-y-auto' style={{ maxHeight: '40vh' }}>
              <div className={styles.skyboxGrid} data-cy='skybox-grid'>
                {items?.map((element, index) => (
                  <div
                    key={`${type}-${index}-skybox`}
                    className={`${styles.skyboxCard}`}
                    data-cy='skybox-card'
                    onClick={() => {
                      callBack({
                        ...element,
                        type,
                        index,
                        hdriType,
                        hdriIntensity,
                        isSkyBox2025: false,
                        envMapType,
                      });
                    }}
                    style={{
                      backgroundImage: `url(${element.thumbnail})`,
                      backgroundSize: '200% 100%',
                    }}
                  >
                    {selectedSkybox?.index === element?.object?.index && (
                      <IconCheck />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </Flex>
        </div>
      </Modal>
    </>
  );
};

export default memo(Sky);
